<div class="recycleBin_buttonBox">
  <div class="recycleBin_button" (click)="openRecycleBin()">
    <span class="stepsNumber">( {{ getDeletedStepsCount() }} )</span>
  </div>
</div>

<div class="recycleBin_container" [@tabState]="state">
  <div class="clickatell-tabs recycleBin_tabs">
    <div class="recycleBin_header">
      <div class="recycleBin_binIcon"></div>
      <label class="recycleBin_label">Deleted Nodes</label>
      <div class="recycleBin_node_container" [@tabContainerState]="tabContainerState">
        @if (nodeIcons$ | async; as nodeIcons) {
          <div class="recycle_container">
            <cdk-tree [dataSource]="dataSource" [treeControl]="treeControl">
              <cdk-tree-node *cdkTreeNodeDef="let node" cdkTreeNodePadding
                [style.display]="shouldRender(node) ? 'flex' : 'none'" class="recycleBin_tree-node"
                [draggable]="isDraggable" (dragstart)="onDragStart($event, node, false)" (dragend)="onDragEnd($event)"
                [style.border-bottom]="node.level === 0 ? '1px solid #dfdfdf' : 'none'" [style.padding-left]="'0px'"
              (click)="nodeClick(node, $event)" [ngClass]="{
                'recycleBin_tree-node_selected': selectedNodes.includes(node.step.stepNumber)
              }">
                @for (n of numSequence(node.level); track $index) {
                  <div class="recycleBin_dropdownLine"
                    [style.border-left]="node.level > 0 ? '1px solid #dfdfdf' : '1px solid transparent'"
                  [style.margin-left]="node.level > 0 ? '24px' : '0px'"></div>
                }
                <label class="recycleBin_stepNumber recycleBin_stepNumber_childNode"
                  [style.margin-left]="node.level > 0 ? '14px' : '16px'">{{
                node.step.stepNumber.slice(node.step.stepNumber.indexOf('p') + 1) }}</label>
                <div class="recycleBin_nodeType">
                  <img class="recycleBin_nodeIcon" [src]="getIconBg(node.step.nodeType)" />
                </div>
                <label class="recycleBin_nodeName">{{ nodeIcons[node.step.nodeType]?.title }}</label>
                <div class="recycleBin_divider"></div>
                <label class="recycleBin_description">{{ node.step.description }}</label>
              </cdk-tree-node>
              <cdk-tree-node *cdkTreeNodeDef="let node; when: hasChild" cdkTreeNodePadding
                [style.display]="shouldRender(node) ? 'flex' : 'none'" class="recycleBin_tree-node"
                [draggable]="isDraggable" (dragstart)="onDragStart($event, node, true)" (dragend)="onDragEnd($event)"
              [style.border-bottom]="
                node.level === 0 && !node.isExpanded ? '1px solid #dfdfdf' : 'none'
              " [style.padding-left]="node.level > 0 ? '0px' : '0px'" (click)="nodeClick(node, $event)" [ngClass]="{
                'recycleBin_tree-node_selected': selectedNodes.includes(node.step.stepNumber)
              }">
                @for (n of numSequence(node.level); track $index) {
                  <div class="recycleBin_dropdownLine"
                    [style.border-left]="node.level > 0 ? '1px solid #dfdfdf' : '1px solid transparent'"
                  [style.margin-left]="node.level > 0 ? '24px' : '0px'"></div>
                }
                <button class="recycleBin_dropDownBtn" mat-icon-button cdkTreeNodeToggle
                  [attr.aria-label]="'Toggle ' + node.step.stepNumber" (click)="node.isExpanded = !node.isExpanded"
                  [style.visibility]="node.expandable ? 'visible' : 'hidden'"
                [style.transform]="treeControl.isExpanded(node) ? 'rotate(90deg)' : 'rotate(0deg)'"></button>
                <ng-container draggable="false">
                  <label class="recycleBin_stepNumber">{{
                    node.step.stepNumber.slice(node.step.stepNumber.indexOf('p') + 1)
                  }}</label>
                  <div class="recycleBin_nodeType">
                    <img class="recycleBin_nodeIcon" [src]="getIconBg(node.step.nodeType)" />
                  </div>
                  <label class="recycleBin_nodeName">{{
                    nodeIcons[node.step.nodeType]?.title
                  }}</label>
                  <div class="recycleBin_divider"></div>
                  <label class="recycleBin_description">{{ node.step.description }}</label>
                </ng-container>
              </cdk-tree-node>
            </cdk-tree>
          </div>
        }
      </div>
    </div>
    @if (selectedNodes.length > 0) {
      <div class="recycleBin_toolbar">
        <img class="recycleBin_toolbar_info" src='../../../../../assets/svg/redesign/Info.svg' />
        <label class="recycleBin_toolbar_infoLabel">Hold Shift to select and delete multiple nodes</label>
        <button class="recycleBin_toolbar_clearButton" (click)="openRecycleBinClearNodesDialog()">
          @if (selectedNodes.length <= 1) {
            <span> Clear Node </span>
          } @else {
            Clear {{ selectedNodes.length }} Nodes
          }
        </button>
      </div>
    }
  </div>
  <button class="recycleBin_arrow" (click)="expandRecyleBin()" [@rotatedState]="rotateState"></button>
  <button class="recycleBin_close" (click)="closeRecycleBin()"></button>
<!-- </div> -->
<!-- </div> -->
</div>

<ng-template #recycleBinClearNodesDialog>
  <div class="recycleBin_ClearNodesDialog">
    <div class="recycleBin_ClearNodesDialog_header">
      <div class="recycleBin_ClearNodesDialog_toolbar">
        <div class="recycleBin_ClearNodesDialog_toolbar_title">
          @if (selectedNodes.length === 0) {
            <span> Clearing Nodes </span>
          } @else {
            Clearing {{ selectedNodes.length }} Nodes
          }
        </div>
        <button class="recycleBin_ClearNodesDialog_toolbar_close-button"
        (click)="closeRecycleBinClearNodesDialog()"></button>
      </div>
    </div>
    <div class="recycleBin_ClearNodesDialog_message">
      <div>
        <img class="recycleBin_ClearNodesDialog_message_image"
          src='../../../../../assets/svg/redesign/ExclamationMark_Red.svg' />
        </div>
        <div class="recycleBin_ClearNodesDialog_message_text">
          Clearing nodes from the recycle bin are not recoverable. Continue with clear?
        </div>
      </div>
      <div class="recycleBin_ClearNodesDialog_buttonsArea">
        <button class="recycleBin_ClearNodesDialog_buttonsArea_cancel" (click)="closeRecycleBinClearNodesDialog()">
          Cancel
        </button>
        <button class="recycleBin_ClearNodesDialog_buttonsArea_clear" (click)="clearNodesClick()">
          Clear
        </button>
      </div>
    </div>
  </ng-template>

  <div id="drag-ghost"></div>